import { Tabs, Tab, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ReactComponent as PositionIcon } from "../../assets/icons/PerformanceDashboard/PositionIcon.svg";
import { ReactComponent as OpenOrderIcon } from "../../assets/icons/PerformanceDashboard/OpenOrderIcon.svg";
import { ReactComponent as OrderHistoryIcon } from "../../assets/icons/PerformanceDashboard/OrderHistoryIcon.svg";
import OrdersTable from "./OrdersTable";
import { useDispatch, useSelector } from "react-redux";
import { getUserTrades } from "../../redux/slices/tradeOrdersSlice";
import { AppDispatch } from "../../redux/store";
import { formatCurrency } from "../OptionsTrading/helpers";
import { useLocation } from "react-router-dom";

const tabData = [
  { icon: PositionIcon, text: "Open Positions" },
  { icon: OpenOrderIcon, text: "Open Orders" },
  { icon: OrderHistoryIcon, text: "Order History" },
];

function PerformanceDashboard() {
  const location = useLocation();
  const [value, setValue] = useState(location.state?.tab || 0);
  const dispatch = useDispatch<AppDispatch>();

  const virtualAccount = useSelector(
    (state: { tradierAccount }) => state.tradierAccount.account,
  );
  useEffect(() => {
    dispatch(getUserTrades({ vendor: "tradier" }));
  }, []);

  console.log("virtual", virtualAccount);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const navigateTab = (tabValue) => {
    setValue(tabValue);
  };

  return (
    <div className="bg-tgpt-black-50">
      <div className="flex flex-col h-dvh p-6 gap-y-6">
        <div className="flex flex-col gap-y-6">
          <h5>Overall Performance</h5>
          <DataDisplaySection virtualAccount={virtualAccount} />
        </div>
        <TabSection value={value} onChange={handleChange} navigateTab={navigateTab} />
      </div>
    </div>
  );
};

const DataDisplaySection = ({ virtualAccount }) => {
  const cashBalance = virtualAccount?.balance_cash ?? 0;
  const portfolioVal = virtualAccount?.balance_holdings ?? 0;

  return (
    <section className="flex gap-x-6">
      <DataCard
        title="Net Account Value"
        value={formatCurrency(portfolioVal + cashBalance)}
      />
      <DataCard
        title="Portfolio Value"
        value={formatCurrency(portfolioVal)}
      />
      {/* <DataCard title="Daily P&L" value="$100,000.00" /> */}
      <DataCard
        title="Cash Balance"
        value={formatCurrency(cashBalance)}
      />
    </section>
  );
};

const DataCard = ({ title, value }) => (
  <div className="bg-white rounded p-4 flex flex-1 flex-col gap-y-2 shadow">
    <p className="subtitle">{title}</p>
    <h5 className="tabular-nums">{value}</h5>
  </div>
);

const TabSection = ({ value, onChange, navigateTab }) => (
  <section className="flex-grow">
    <div className="bg-white rounded shadow flex flex-col h-full">
      <Tabs value={value} onChange={onChange} className="tabs-item" aria-label="tabs">
        {tabData.map((tab, index) => (
          <Tab
            key={index}
            value={index}
            label={(
              <TabLabel
                icon={tab.icon}
                text={tab.text}
                selected={value === index}
              />
            )}
          />
        ))}
      </Tabs>
      <OrdersTable value={value} navigateTab={navigateTab} />

    </div>
  </section>
);

const TabLabel = ({ icon: Icon, text, selected }) => (
  <div className="flex items-center gap-x-2">
    <Icon className={selected ? "fill-blue-400" : "fill-current"} />
    <Typography variant="body2">{text}</Typography>
  </div>
);
export default PerformanceDashboard;
